import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';

const { colors, spacing } = THEME;

export const mobileStyles = StyleSheet.create({
	container: {
		backgroundColor: colors.background.light,
		display: 'flex',
		flexDirection: 'column',
		height: '100vh',
		maxWidth: '100vw',
		overflow: 'hidden',
		position: 'relative',
	},
	content: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		justifyContent: 'flex-start',
		overflow: 'hidden',
	},
	scrollableContent: {
		flex: 1,
		overflowY: 'auto',
		padding: spacing.md,
		paddingBottom: spacing.sm,
	},
	section: {
		marginBottom: spacing.md,
	},
	errorMessage: {
		backgroundColor: colors.danger.light,
		border: `1px solid ${colors.danger.main}`,
		borderRadius: 8,
		color: colors.danger.main,
		fontSize: 14,
		marginBottom: spacing.md,
		padding: spacing.sm,
	},
	warningMessage: {
		backgroundColor: colors.warning.light,
		border: `1px solid ${colors.warning.main}`,
		borderRadius: 8,
		color: colors.warning.main,
		fontSize: 14,
		marginBottom: spacing.md,
		padding: spacing.sm,
	},
	loadingContainer: {
		alignItems: 'center',
		display: 'flex',
		flex: 1,
		justifyContent: 'center',
		padding: spacing.xl,
	},
	loadingText: {
		fontSize: 16,
		marginTop: spacing.md,
	},
	divider: {
		backgroundColor: colors.border.light,
		border: 'none',
		height: 1,
		margin: `${spacing.md}px 0`,
		width: '100%',
	},
	// MobileActionButtons styles
	actionButtonsContainer: {
		backgroundColor: colors.background.light,
		borderTop: `1px solid ${colors.border.light}`,
		padding: spacing.md,
		position: 'sticky',
		bottom: 0,
		zIndex: 10,
		marginBottom: 24,
	},
	actionButtons: {
		display: 'flex',
		flexDirection: 'row',
		gap: spacing.sm,
		marginTop: spacing.sm,
	},
	// Mobile-specific styles for ImageUploadButtons
	mobileImageUploadContainer: {
		display: 'flex',
		justifyContent: 'space-between',
		gap: spacing.sm,
		width: '100%',
		marginBottom: spacing.sm,
	},
	mobileImageUploadButtonGroup: {
		display: 'flex',
		flexDirection: 'column',
		flex: 1,
	},
	mobileImageUploadButton: {
		alignItems: 'center',
		backgroundColor: colors.background.light,
		border: `1px solid ${colors.border.main}`,
		borderRadius: 8,
		color: colors.text.main,
		cursor: 'pointer',
		display: 'flex',
		fontSize: 14,
		fontWeight: 500,
		justifyContent: 'center',
		minHeight: 48,
		outline: 'none',
		padding: spacing.sm,
		transition: 'background-color 0.2s ease, border-color 0.2s ease',
		width: '100%',
		':hover': {
			backgroundColor: colors.background.dark,
			borderColor: colors.primary.light,
		},
		':active': {
			backgroundColor: colors.background.dark,
		},
	},
	mobileImageUploadSourceText: {
		color: colors.text.light,
		fontSize: 11,
		fontStyle: 'italic',
		lineHeight: 1.3,
		marginTop: 4,
		textAlign: 'center',
	},
	scheduleButton: {
		backgroundColor: colors.primary.main,
		border: 'none',
		borderRadius: 8,
		color: colors.primary.contrastText,
		cursor: 'pointer',
		fontSize: 16,
		fontWeight: 600,
		minHeight: 48,
		outline: 'none',
		padding: `${spacing.sm}px ${spacing.lg}px`,
		textAlign: 'center',
		transition: 'background-color 0.2s ease',
		flex: 1,
		':hover': {
			backgroundColor: colors.primary.dark,
		},
		':disabled': {
			backgroundColor: colors.icon.disabled,
			cursor: 'not-allowed',
		},
	},
	// MobileImageCarousel styles
	imageCarouselContainer: {
		marginBottom: spacing.lg,
	},
	imageCarouselImageContainer: {
		backgroundColor: '#f5f5f5',
		borderRadius: 12,
		overflow: 'hidden',
		position: 'relative',
		height: 300,
		width: '100%',
	},
	imageCarouselImage: {
		cursor: 'pointer',
		display: 'block',
		height: '100%',
		objectFit: 'cover',
		width: '100%',
	},
	imageCarouselRemoveButton: {
		alignItems: 'center',
		backgroundColor: 'rgba(0, 0, 0, 0.7)',
		border: 'none',
		borderRadius: '50%',
		color: colors.background.light,
		cursor: 'pointer',
		display: 'flex',
		fontSize: 24,
		height: 32,
		justifyContent: 'center',
		position: 'absolute',
		right: 8,
		top: 8,
		width: 32,
		zIndex: 2,
		':hover': {
			backgroundColor: 'rgba(0, 0, 0, 0.9)',
		},
	},
	imageCarouselNavButton: {
		alignItems: 'center',
		backgroundColor: 'rgba(0, 0, 0, 0.5)',
		border: 'none',
		borderRadius: '50%',
		color: colors.background.light,
		cursor: 'pointer',
		display: 'flex',
		fontSize: 24,
		height: 40,
		justifyContent: 'center',
		position: 'absolute',
		top: '50%',
		transform: 'translateY(-50%)',
		width: 40,
		zIndex: 2,
		':hover': {
			backgroundColor: 'rgba(0, 0, 0, 0.7)',
		},
	},
	imageCarouselPrevButton: {
		left: 8,
	},
	imageCarouselNextButton: {
		right: 8,
	},
	imageCarouselIndicators: {
		display: 'flex',
		gap: spacing.sm,
		justifyContent: 'center',
		marginTop: 12,
	},
	imageCarouselIndicator: {
		backgroundColor: colors.secondary.main,
		border: 'none',
		borderRadius: '50%',
		cursor: 'pointer',
		height: 8,
		opacity: 0.5,
		transition: 'opacity 0.2s ease',
		width: 8,
		':hover': {
			opacity: 0.8,
		},
	},
	imageCarouselIndicatorActive: {
		backgroundColor: colors.primary.main,
		opacity: 1,
	},
	imageCarouselCounter: {
		color: colors.secondary.main,
		fontSize: 12,
		marginTop: spacing.sm,
		textAlign: 'center',
	},
	// MobileContentEditor styles
	contentEditorContainer: {
		marginBottom: spacing.lg,
	},
	contentEditorHeader: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		marginBottom: spacing.sm,
	},
	contentEditorLabel: {
		color: colors.text.light,
		fontSize: 14,
	},
	contentEditorTextAreaContainer: {
		position: 'relative',
	},
	contentEditorTextArea: {
		backgroundColor: colors.background.light,
		border: `1px solid ${colors.border.light}`,
		borderRadius: 8,
		boxSizing: 'border-box',
		color: colors.text.main,
		fontFamily: 'inherit',
		fontSize: 16,
		lineHeight: 1.5,
		height: 120,
		outline: 'none',
		padding: spacing.md,
		resize: 'none',
		transition: 'border-color 0.2s ease',
		width: '100%',
		':focus': {
			borderColor: colors.primary.main,
			boxShadow: `0 0 0 2px ${colors.primary.light}`,
		},
		'::placeholder': {
			color: colors.text.light,
		},
	},
	contentEditorTextAreaReadOnly: {
		backgroundColor: colors.background.dark,
		cursor: 'not-allowed',
		':focus': {
			borderColor: colors.border.light,
			boxShadow: 'none',
		},
	},
	contentEditorCharCount: {
		color: colors.text.light,
		fontSize: 12,
		textAlign: 'right',
	},
	contentEditorCharCountError: {
		color: colors.danger.main,
	},
	// MobileWhereToShare styles
	whereToShareContainer: {
		marginBottom: 0,
	},
	whereToShareLabel: {
		color: colors.primary.main,
		fontSize: 16,
		fontWeight: 600,
		marginBottom: spacing.sm,
	},
	whereToShareSelectButton: {
		alignItems: 'center',
		backgroundColor: 'transparent',
		border: 'none',
		cursor: 'pointer',
		display: 'flex',
		fontSize: 16,
		justifyContent: 'space-between',
		minHeight: 32,
		outline: 'none',
		padding: '4px 0',
		position: 'relative',
		width: 'auto',
	},
	whereToShareSelectButtonReadOnly: {
		cursor: 'not-allowed',
		opacity: 0.6,
	},
	whereToShareSelectButtonText: {
		color: colors.text.light,
		flex: 1,
		fontSize: 16,
		fontWeight: 400,
		textAlign: 'left',
	},
	whereToShareChevronIcon: {
		color: colors.secondary.main,
		height: 20,
		marginLeft: spacing.sm,
		transition: 'transform 0.2s ease',
		width: 20,
	},
	whereToShareChevronIconOpen: {
		transform: 'rotate(180deg)',
	},
	whereToSharePopover: {
		marginTop: 4,
		minWidth: 280,
	},
	whereToShareDropdownContainer: {
		backgroundColor: colors.background.light,
		borderRadius: 8,
		boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
		maxHeight: 300,
		overflowY: 'auto',
		padding: spacing.sm,
	},
	whereToShareConnectionItem: {
		alignItems: 'center',
		borderRadius: 6,
		cursor: 'pointer',
		display: 'flex',
		justifyContent: 'space-between',
		minHeight: 48,
		padding: `${spacing.sm}px 12px`,
		transition: 'background-color 0.2s ease',
		':hover': {
			backgroundColor: '#f5f5f5',
		},
	},
	whereToShareConnectionInfo: {
		flex: 1,
	},
	whereToShareConnectionName: {
		color: colors.text.light,
		fontSize: 14,
		fontWeight: 500,
	},
	whereToShareConnectionSubtext: {
		color: colors.secondary.main,
		fontSize: 12,
		marginTop: 2,
	},
	whereToShareCheckboxContainer: {
		alignItems: 'center',
		display: 'flex',
		height: 20,
		justifyContent: 'center',
		width: 20,
	},
	whereToShareCheckIcon: {
		color: colors.primary.main,
		height: 16,
		width: 16,
	},
	whereToShareNoAccounts: {
		color: colors.secondary.main,
		fontSize: 14,
		fontStyle: 'italic',
		padding: spacing.md,
		textAlign: 'center',
	},
	// Fullscreen modal styles
	fullscreenModal: {
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: 'rgba(0, 0, 0, 0.95)',
		zIndex: 9999,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
	},
	fullscreenHeader: {
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: spacing.md,
		zIndex: 10000,
	},
	fullscreenCloseButton: {
		backgroundColor: 'rgba(255, 255, 255, 0.2)',
		border: 'none',
		borderRadius: '50%',
		color: colors.background.light,
		cursor: 'pointer',
		fontSize: 24,
		height: 40,
		width: 40,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		transition: 'background-color 0.2s ease',
		':hover': {
			backgroundColor: 'rgba(255, 255, 255, 0.3)',
		},
	},
	fullscreenCounter: {
		color: colors.background.light,
		fontSize: 14,
		fontWeight: 'bold',
	},
	fullscreenImageContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: '100%',
		width: '100%',
		padding: spacing.md,
		maxHeight: '100vh',
		maxWidth: '100vw',
	},
	fullscreenImage: {
		maxHeight: '100%',
		maxWidth: '100%',
		objectFit: 'contain',
		borderRadius: 8,
	},
	fullscreenNavButton: {
		backgroundColor: 'rgba(255, 255, 255, 0.2)',
		border: 'none',
		borderRadius: '50%',
		color: colors.background.light,
		cursor: 'pointer',
		fontSize: 32,
		fontWeight: 'bold',
		height: 50,
		position: 'absolute',
		top: '50%',
		transform: 'translateY(-50%)',
		width: 50,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		transition: 'background-color 0.2s ease',
		zIndex: 10000,
		':hover': {
			backgroundColor: 'rgba(255, 255, 255, 0.3)',
		},
	},
	fullscreenPrevButton: {
		left: spacing.md,
	},
	fullscreenNextButton: {
		right: spacing.md,
	},
});
